//* German. Translated by: Jack O'Connor (jackocnr).
export default {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo",
};
